














import axios from 'axios';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ProductList from './ProductList.vue';
import ProductFilter from './ProductFilter.vue';
import { Product, ProductListItem } from '@/models/Product';
import { FacetInfo } from '@/models/Product';

@Component({
    components: {
        ProductList,
        ProductFilter
    }
})
export default class Category extends Vue {
    protected products: ProductListItem[];
    protected facetInfo: FacetInfo;
    protected hideColorList: Boolean;
    constructor() {
        super();
        this.products = JSON.parse(this.$attrs['data-products']);
        this.facetInfo = JSON.parse(this.$attrs['data-facet-info']);
        this.hideColorList =
            this.$attrs['data-hide-color-list'] == 'True' ? true : false;

       
        // console.log(this.facetInfo);
        // console.log(this.facetInfo.SortItems);

        this.$attrs['data-products'] = '';
        this.$attrs['data-facet-info'] = '';
        this.$attrs['data-hide-color-list'] = '';
    }
    public getLinkContent(link: string) {
        // console.log('get link content');

        if (link != null) {
            const requestContext = (window as any).__litium.requestContext;
            const queryString =
                link.indexOf('?') > -1 ? link.substring(link.indexOf('?')) : '';
            axios({
                method: 'get',
                url: '/api/productfilter' + queryString,
                headers: {
                    'litium-request-context': JSON.stringify(requestContext)
                }
            })
                .then((response: any) => {
                    // console.log(response.data.products);
                    // console.log(response.data.facetInfo);

                    const url =
                        window.location.href.replace(
                            window.location.search,
                            ''
                        ) + queryString;

                    this.products = JSON.parse(response.data.products);
                    this.facetInfo = JSON.parse(response.data.facetInfo);

                    // console.log(this.products);
                    // console.log(this.facetInfo);

                    window.history.pushState(
                        'facet search',
                        'facet search',
                        url
                    );
                })
                .catch((response: any) => {
                    // handle error
                    // console.log(response);
                });
        }
    }
}
